<template>
  <div id="app" v-if="coursewareInitState">
    <router-view />
    <audio :src="audioSrc" ref="examAudio" @error="audioError"></audio>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      // 课件初始化状态
      coursewareInitState: true,
      // 查询音频准备时长
      timerNum: 0,
      currentPath: null
    }
  },
  computed: {
    ...mapState({
      // 在线课程和接口学课小测验音频数据
      setPalyer: state => state.autoPalyer,
      audioState: state => state.audioState,
      audioSrc: state => state.audioSrc
    })
  },
  created () {
    // this.setScormLang()
    let u = navigator.userAgent
    // 初始化lessonLocation
    this.initLessonPos()
    if (
      !!u.match(/AppleWebKit.*Mobile.*/) ||
      (!!u.match(/AppleWebKit/) &&
        u.indexOf('QIHU') &&
        u.indexOf('QIHU') > -1 &&
        u.indexOf('Chrome') < 0)
    ) {
      // let iframeFlag = $('iframe')
      // debugger
      // if(self.frameElement && self.frameElement.tagName == "IFRAME"){
      //   // 　alert('在iframe中');
      //   //iframe 只有竖屏，不需要切换成横屏  解决安卓视频全屏播放会自动全屏与当前竖屏冲突
      //   this.$router.replace("/h5Dindex");
      // }else {
      //   this.redirectToPage(window.orientation);
      //   window.addEventListener("orientationchange", () => {
      //     this.redirectToPage(window.orientation);
      //   });
      // }
      if(!location.href.includes('h5Dindex/preview')){
        this.$router.replace({ path: '/h5Dindex', query: { ...this.$route.query } })
        if (this.$global_config.is_landscape) {
          this.redirectToPage(window.orientation)
          window.addEventListener('orientationchange', () => {
            this.redirectToPage(window.orientation)
          })
        }
      }
    } else {
      if(!location.href.includes('pcindex/preview')){
        this.$router.replace('/pcindex')
      }
    }
  },
  mounted () {
    document.title = this.data.res_title ? this.data.res_title : '\u200E'
    if (this.$global_config.lesson.type != 1) {
      window.addEventListener('unload', () => {
        doQuit()
      })
    }

    // 监听播放器状态
    this.watchMusicState()
    this.$refs.examAudio.load()
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        // 页面被挂起
        this.$refs.examAudio.pause()
        this.$store.commit('setAutoPlayer', false)
      }
    })
  },
  methods: {
    ...mapMutations(['setAudioState', 'setAutoPlayer']),
    redirectToPage (angle) {
      switch (angle) {
        case 0:
          if(!location.href.includes('h5Dindex/preview')) {
            this.$router.replace({ path: '/h5Dindex', query: { ...this.$route.query } })
          } else {
            this.$router.replace({ path: '/h5Dindex/preview', query: { ...this.$route.query, show: 'views_d' }})
          }
          break
        case 90:
          if(!location.href.includes('h5Dindex/preview')) {
            this.$router.replace({ path: '/h5Rindex', query: { ...this.$route.query}})
          } else {
            this.$router.replace({ path: '/h5Dindex/preview', query: { ...this.$route.query, show: 'views_r', redirect: 'h5Rindex' } })
          }
          // this.$layer.msg('暂不支持横屏样式')
          break
        case -90:
          if(!location.href.includes('h5Dindex/preview')) {
            this.$router.replace({ path: '/h5Rindex', query: { ...this.$route.query } })
          } else {
            this.$router.replace({ path: '/h5Dindex/preview', query: { ...this.$route.query, show: 'views_r', redirect: 'h5Rindex' } })
          }
          break
        default:
          break
      }
    },
    initLessonLocation () {
      let lessonArr = []
      this.data.part_list.forEach((item, index) => {
        let str = ''
        item.chapter_list.forEach((itm) => {
          str += '0'
        })
        lessonArr[index] = str
      })
      let lessonLocation = lessonArr.join('|') + '||0-0'
      this.$store.commit('lessonLocation', lessonLocation)
      localStorage.setItem(this.data.scorm_id + 'lessonLocation', lessonLocation)
      /* 默认第一小节 */
      this.$store.commit('cur_data', this.data.part_list[0].chapter_list[0])
      this.$store.commit('currentPartIndex', 0)
      this.$store.commit('currentChapterIndex', 0)
      if (this.data.part_list[0].chapter_list.length > 1) {
        this.$store.commit('next_data', this.data.part_list[0].chapter_list[1])
      } else if (this.data.part_list.length > 1) {
        this.$store.commit('next_data', this.data.part_list[1].chapter_list[0])
      }
    },
    initLessonPos () { // 初始化
      // debugger
      const scormId = this.data.scorm_id

      let scormInitFlag = false
      if (this.$global_config.lesson.type != 1) {
        loadPage()
        scormInitFlag = LMSIsInitialized()
        console.log('=====================================scorm是否初始化完毕', scormInitFlag)
      }
      if (scormInitFlag == false && this.$global_config.lesson.type == 2) {
        this.coursewareInitState = false
        this.$layer.msg(this.$t('scromLoadFailed'))
      } else {
        this.$store.commit('isScormFlag', scormInitFlag)
        if (scormInitFlag) {
          // scorm类型且scorm初始化已完成
          try {
            let lessonPos = doLMSGetValue('cmi.core.lesson_location')
            console.log('=====================================scorm是否获取到小节学习进度', lessonPos)
            if (lessonPos) { // 存在进度，保存进入并传给vuex
              this.$store.commit('lessonLocation', lessonPos)
              this.getLessonLocation()
            } else { // 不存在，则初始化
              this.initLessonLocation()
              // this.$store.commit("isHavePrev",false)
            }
          } catch (err) {
            console.log(err, '====> scrom 初始化失败错误问题。')
            if (this.$global_config.lesson.type == 3) { // 混合模式，则自动启用纯h5
              this.$store.commit('isScormFlag', false)
              if (localStorage.getItem(scormId + 'lessonLocation')) {
                this.getLessonLocation()
              } else {
                this.initLessonLocation()
              }
            } else {
              this.coursewareInitState = false
              this.$layer.msg(this.$t('scromLoadFailed'))
            }
          }
        } else {
          if (localStorage.getItem(scormId + 'lessonLocation')) {
            this.getLessonLocation()
          } else {
            this.initLessonLocation()
          }
        }
      }
    },

    // 播放出错
    audioError () {
      if (this.audioSrc) {
        this.$layer.msg(this.$t('audioLoadFailed'))
        let $audio = this.$refs.examAudio
        $audio.pause()
      }
    },
    // 开始播放
    startPlayAudio () {
      if (!this.audioSrc) {
        return this.setAutoPlayer(false)
      }
      let $audio = this.$refs.examAudio// 获取音乐DOM节点
      $audio.currentTime = 0
      $audio.load()
      this.watchReadySatet()
    },
    // 轮询音频加载状态
    watchReadySatet () {
      let $audio = this.$refs.examAudio
      if ($audio.readyState || this.timerNum > 3) {
        $audio.play()
        this.timerNum = 0
        if ($audio.paused) {
          this.setAutoPlayer(false)
          this.$layer.msg(this.$t('audioPlayback'))
        }
      } else {
        setTimeout(() => {
          this.timerNum = this.timerNum + 1
          this.watchReadySatet()
        }, 500)
      }
    },
    // 关闭播放音频
    closeAudio () {
      let $audio = this.$refs.examAudio// 获取音乐DOM节点
      this.$nextTick(() => {
        if (!$audio.paused) {
          $audio.pause()
        }
      })
    },
    // 开始播放音频
    audioSatrt () {
      let $audio = this.$refs.examAudio// 获取音乐DOM节点
      this.$nextTick(() => {
        if ($audio.paused) {
          $audio.play()
        }
      })
    },
    // 监听音乐播放状态：改变播放或暂停按钮
    watchMusicState () {
      let $audio = this.$refs.examAudio// 获取音乐DOM节点
      $audio.addEventListener('playing', () => {		// 播放状态Doing
        this.setAudioState('playing')
      })
      $audio.addEventListener('pause', () => { // 暂停状态Doing
        this.setAudioState('pause')
      })
      $audio.addEventListener('ended', () => { // 暂停状态Doing
        this.setAudioState('ended')
        this.setAutoPlayer(false)
      })
    },
    // 设置语言
    setScormLang () {
      if (this.$global_config.language.open && this.$route.query[this.$global_config.language.lang_key]) {
        this.$i18n.locale = this.$route.query[this.$global_config.language.lang_key]
      }
    }
  },
  watch: {
    // 设置音频播放
    setPalyer (newVal) {
      if (newVal && this.audioState === 'ended') {
        this.startPlayAudio()
      } else if (newVal) {
        this.audioSatrt()
      } else {
        this.closeAudio()
      }
    },
    audioSrc (newVal) {
      this.$store.commit('setAudioState', 'ended')
      if (newVal) {
        // 监听播放器状态
        this.$refs.examAudio.load()
        this.$nextTick(() => {
          if (this.setPalyer) {
            this.startPlayAudio()
          }
        })
      } else {
        this.closeAudio()
      }
    }
  }
}
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  background: white;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  -webkit-text-size-adjust: 100%;
  user-select: none;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.logo-box {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
</style>
